import { Section } from "@affinity/components/Section";
import { Wrapper } from "@affinity/components/Wrapper";
import { CustomState } from "@affinity/Store/Reducers";
import { useShellContext } from "@insite/client-framework/Components/IsInShell";
import { redirectTo } from "@insite/client-framework/ServerSideRendering";
import {
    ExcludeFromNavigation,
    ExcludeFromSignInRequired,
    HideFooter,
    HideFromSearchEngines,
    HideHeader,
} from "@insite/client-framework/Types/FieldDefinition";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Page from "@insite/mobius/Page";
import Typography from "@insite/mobius/Typography";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";

// Fields Keys Enumerator
const enum fields {
    addressnowKey = "addressnowKey",
}

// CMS Properties Types for Component Usage
interface AffinitySettingsProps extends PageProps {
    fields: {
        [fields.addressnowKey]: string;
        // Reference additional fields required here with relevant typings
    };
}

// Page Implementation
const AffinitySettings: React.FC<AffinitySettingsProps> = ({ fields }) => {
    const { isInShell } = useShellContext();
    if (!isInShell) {
        redirectTo("/");
    }

    return (
        <Page hasCustomBackground>
            {isInShell && (
                <Wrapper>
                    <Typography variant="h1">Settings</Typography>
                    <Section title="Edit setting in the panel on the left to see the changes here">
                        <code>
                            <dl>
                                <dt>AddressNow key:</dt>
                                <dd>{fields.addressnowKey}</dd>
                            </dl>
                        </code>
                    </Section>
                </Wrapper>
            )}
        </Page>
    );
};

// CMS Property Definitions
const pageModule: PageModule = {
    component: AffinitySettings,
    definition: {
        hasEditableTitle: true,
        hasEditableUrlSegment: true,
        pageType: "Content",
        fieldDefinitions: [
            {
                name: fields.addressnowKey,
                displayName: "AddressNow key",
                defaultValue: "",
                editorTemplate: "TextField",
                fieldType: "General",
                isRequired: true,
                sortOrder: 1,
            },
            HideHeader,
            HideFooter,
            ExcludeFromNavigation,
            ExcludeFromSignInRequired,
            HideFromSearchEngines,
        ],
    },
};

export default pageModule;
export const FunctionalComponentsContext = "AffinitySettings";
